import { NotFound } from '@/components/Message/NotFound';
import { TFunction } from 'i18next';

interface NoTableDataFoundProps {
  t: TFunction<undefined>;
}

export const NoTableDataFound = ({ t }: NoTableDataFoundProps) => {
  return (
    <div className="pt-12 pb-10 flex justify-center">
      <NotFound text={`${t('common:noDataFound')}...`} />
    </div>
  );
};
